export default "__VITE_ASSET__ByLvrFj___"